import React, { FunctionComponent } from 'react';

import styles from './InstagramPostCardStatus.module.scss';
import { nFormatter } from 'app/utils/numbersFormater';
import { _t } from 'app/utils/i18n';

interface Props {
  likes_count: number;
  comments_count: number;
  views_count?: number;
  post_type?: string;
}

const InstagramPostCardStatus: FunctionComponent<Props> = ({
  comments_count,
  likes_count,
  views_count,
  post_type,
}) => {
  return (
    <div className={`${styles.InstagramPostCardStatus}`}>
      <div className="flex-column-reverse">
        <span className="instagramColor">{nFormatter(likes_count)}</span>
        <span className="tweetSubTitleColor">{_t('trends:likes')}</span>
      </div>
      {comments_count > 0 && (
        <div className="flex-column-reverse">
          <span className="instagramColor">{nFormatter(comments_count)}</span>
          <span className="tweetSubTitleColor">{_t('trends:comments')}</span>
        </div>
      )}
      {(post_type === 'REEL' || post_type === 'IGTV') && (
        <div className="flex-column-reverse">
          <span className="instagramColor">{nFormatter(views_count)}</span>
          <span className="tweetSubTitleColor">{_t('basic:views')}</span>
        </div>
      )}
    </div>
  );
};

export default InstagramPostCardStatus;
